import React from 'react';
import Style from './carousel.module.css';
/** @jsxImportSource @emotion/react */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

const Carousel = props => {
  const carouselId = `carousel-${React.useId()}`;
  const propsArray = [];
  propsArray.className = props.className === undefined ? '' : props.className;
  propsArray.height = props.height === undefined ? '350' : props.height;
  const startPoint = React.useRef(0);
  let emotionStyle = [];

  if (props.ms !== undefined) {
    emotionStyle = props.ms;
  }

  React.useEffect(() => {
    let interval;
    let dragged = false;
    let oldX = 0;

    if (propsArray.height === 0) {
      document.getElementById(carouselId).style.height = document.getElementById(carouselId).offsetWidth + 'px';
    } else {
      document.getElementById(carouselId).style.height = propsArray.height + 'px';
    }

    document.querySelector(`.${Style.carousel}`).addEventListener('mouseenter', function () {
      clearInterval(interval);
    });
    document.querySelector(`.${Style.carousel}`).addEventListener('mouseleave', function () {
      start(carouselImg, indicator, startPoint);
    });
    document.querySelector(`.${Style.carousel} .${Style.navigator} span:first-child`).addEventListener('click', function () {
      prev(carouselImg, indicator, startPoint);
    });
    document.querySelector(`.${Style.carousel} .${Style.navigator} span:last-child`).addEventListener('click', function () {
      next(carouselImg, indicator, startPoint);
    });
    window.addEventListener('mousedown', function (e) {
      oldX = e.pageX;
      dragged = false;
    });
    document.addEventListener('mousemove', function () {
      dragged = true;
    });
    window.addEventListener('mouseup', function (e) {
      if (dragged === true && e.pageX < oldX) {
        prev(carouselImg, indicator, startPoint);
      } else if (dragged === true && e.pageX > oldX) {
        next(carouselImg, indicator, startPoint);
      }
    });
    const carouselImg = document.querySelectorAll(`.${Style.carousel} .${Style.body} img`);
    const indicator = document.querySelectorAll(`.${Style.carousel} .${Style.indicator} span`);
    indicator[0].classList.add(Style.active);
    carouselImg[0].style.opacity = '1';
    start(carouselImg, indicator, startPoint);
  });

  const start = (carouselImg, indicator, startPoint) => {
    setInterval(() => {
      if (startPoint.current < carouselImg.length - 1) {
        carouselImg[startPoint.current].style.opacity = '0';
        carouselImg[startPoint.current + 1].style.opacity = '1';
        indicator[startPoint.current].classList.remove(`${Style.active}`);
        indicator[startPoint.current + 1].classList.add(`${Style.active}`);
        startPoint.current++;
      } else {
        carouselImg[startPoint.current].style.opacity = '0';
        indicator[startPoint.current].classList.remove(`${Style.active}`);
        startPoint.current = 0;
        carouselImg[startPoint.current].style.opacity = '1';
        indicator[startPoint.current].classList.add(`${Style.active}`);
      }
    }, 8000);
  };

  const prev = (carouselImg, indicator, startPoint) => {
    if (startPoint.current > 0) {
      carouselImg[startPoint.current - 1].style.opacity = '1';
      carouselImg[startPoint.current].style.opacity = '0';
      indicator[startPoint.current].classList.remove(`${Style.active}`);
      indicator[startPoint.current - 1].classList.add(`${Style.active}`);
      startPoint.current--;
    }
  };

  const next = (carouselImg, indicator, startPoint) => {
    if (startPoint.current < carouselImg.length - 1) {
      carouselImg[startPoint.current].style.opacity = '0';
      carouselImg[startPoint.current + 1].style.opacity = '1';
      indicator[startPoint.current].classList.remove(`${Style.active}`);
      indicator[startPoint.current + 1].classList.add(`${Style.active}`);
      startPoint.current++;
    } else {
      carouselImg[startPoint.current].style.opacity = '0';
      indicator[startPoint.current].classList.remove(`${Style.active}`);
      startPoint.current = 0;
      carouselImg[startPoint.current].style.opacity = '1';
      indicator[startPoint.current].classList.add(`${Style.active}`);
    }
  };

  return _jsxs(React.Fragment, {
    children: [propsArray.className === '' && _jsx("div", {
      id: carouselId,
      className: `${Style.carousel} ${propsArray.className}`,
      css: emotionStyle,
      children: _jsx("div", {
        className: Style.body,
        children: props.children
      })
    }), propsArray.className !== '' && _jsx("div", {
      id: carouselId,
      className: `${Style.carousel}`,
      css: emotionStyle,
      children: _jsx("div", {
        className: Style.body,
        children: props.children
      })
    })]
  });
};

Carousel.Indicator = props => {
  let emotionStyle = [];

  if (props.ms !== undefined) {
    emotionStyle = props.ms;
  }

  return _jsx(React.Fragment, {
    children: _jsx("div", {
      className: Style.indicator,
      css: emotionStyle,
      children: props.children
    })
  });
};

Carousel.Navigator = props => {
  let emotionStyle = [];

  if (props.ms !== undefined) {
    emotionStyle = props.ms;
  }

  return _jsx(React.Fragment, {
    children: _jsx("div", {
      className: Style.navigator,
      css: emotionStyle,
      children: props.children
    })
  });
};

export default Carousel;